import styled from 'styled-components';
import colors from '../../../assets/colors';

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: ${props => (props.selected ? 0 : '20px')};
  background-color: ${colors.white};
  border-radius: 8px;
  border-bottom-left-radius: ${props => (props.selected ? 0 : '8px')};
  border-bottom-right-radius: ${props => (props.selected ? 0 : '8px')};
  -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;

  .row {
    width: 180px;
    margin-right: 25px;

    h2 {
      font-size: 0.9rem;
      font-weight: 700;
      letter-spacing: -0.3px;
      white-space: nowrap;
    }

    h2.status-waiting { color: #FFB300; }
    h2.status { color: ${colors.primary}; }
    h2.cancelled { color: ${colors.red}; }

    p, .date {
      font-size: 0.9rem;
      font-weight: 400;
      color: #999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .progress-bar {
      margin-top: 8px;
      width: 70px;
      height: 2px;
      display: flex;

      .bar {
        width: 100%;
        height: 2px;
        background-color: #CCC;
      }

      .dot-container {
        flex: 1;
        display: flex;

        .dot {
          margin-top: -3px;
          background-color: #CCC;
          width: 8px;
          height: 8px;
          border-radius: 10px;
        }

        :last-child { max-width: 8px; }
      }

      .active { background-color: ${colors.primary} !important; }
    }
  }

  .last-row {
    min-width: 125px;
  }

  .button-container {
    display: flex;
    min-width: 422px;
    border-left: 1px solid #CCC;
    padding-left: 25px;
  }

  @media screen and (max-width: 1151px) {
    flex-direction: column;
    align-items: flex-start;

    .row {
      width: 100%;
      max-width: 100%;
      padding-bottom: 15px;
      margin-right: 0;
      margin-bottom: 15px;
      border-bottom: 1px solid #E9E9E9;
    }

    .last-row { border: none; }

    .button-container {
      width: 100%;
      min-width: 100%;
      padding: 0 0 10px;
      border: none;
      justify-content: center;

      .space { display: none; }
    }
  }

  @media screen and (max-width: 519px) {
    .button-container {
      flex-direction: column;

      button {
        width: 100%;
        max-width: 100%;
        height: 41px;
        margin-bottom: 10px;

        :last-child { margin: 0; }
      }
    }
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 144px;
  height: 35px;
  padding: 0 20px;
  margin-right: 10px;
  background: none;
  border-radius: 100px;
  border: ${(props) => {
    if (props.cancel) return `2px solid ${colors.red}`;
    return `2px solid ${colors.primary}`;
  }};
  color: ${(props) => {
    if (props.cancel) return `${colors.red}`;
    return `${colors.primary}`;
  }};
  font-family: 'Open Sans', sans-serif;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: -0.5px;
  outline: none;
  cursor: pointer;

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  :hover { opacity: .9; }

  :last-child {
    background: ${colors.primary};
    background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
    margin-right: 0;
    color: #FFF;
    border: none;

    .fa { margin-left: 5px; }
  }

  .fa {
    font-size: 0.9rem;
    margin-right: 4px;
  }

  .fa-truck { width: 25px; }
  .fa-angle-down, .fa-angle-up { font-size: 1.0rem; margin: 0; margin-left: 3px !important; }
  
  @media screen and (max-width: 519px) {
    .fa-truck { font-size: 1.0rem; }
  }
`;

export const Details = styled.div`
  display: ${props => (props.selected ? 'block' : 'none')};
  margin-top: -3px;
  margin-bottom: 20px;
  background-color: #FDFDFD;
  -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  .spacer {
    background-repeat: repeat-x;
    width: 100%;
    height: 15px;
  }

  .container {
    padding: 5px 20px 20px;

    h2 { font-size: 1.0rem; }

    p, .date {
      font-size: 0.9rem;
      color: #999;
    }

    .progress-bar {
      margin: 80px 0 35px;
      width: 50%;
      height: 2px;
      display: flex;

      .bar {
        width: 100%;
        height: 2px;
        background-color: #CCC;
      }

      .dot-container {
        flex: 1;
        display: flex;

        .status-container {
          position: absolute;
          margin-top: -50px;

          .status {
            font-weight: 700;
            color: #000;
            letter-spacing: -0.3px;
            margin-bottom: -2px;
          }
        }

        .active-status { color: ${colors.primary} !important; }

        .dot {
          margin-top: -3px;
          background-color: #CCC;
          width: 8px;
          height: 8px;
          border-radius: 10px;
        }

        :last-child { max-width: 8px; }
      }

      .active { background-color: ${colors.primary} !important; }
    }

    .row-2 {
      display: flex;
      margin-bottom: 25px;

      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-right: 15px;

        :last-child { margin: 0; }

        span {
          color: #000;
          font-weight: 700;
          font-size: 0.9rem;
          letter-spacing: -0.3px;
          padding-bottom: 2px;
        }

        .shipping-date { color: ${props => (props.cancelled ? '#000' : '#FFB300')} }
      }

      .address p span {
        font-weight: 400;
        padding-right: 5px;
      }
    }

    .cancelled {
      margin-top: 25px;

      .info span { color: ${colors.red}; }
    }

    .last-row { margin-bottom: 35px; }

    .order-totals {
      display: flex;
      flex-direction: row-reverse;
      padding: 20px;
      background-color: #F1F1F1;

      .order-table {
        width: 100%;
        max-width: 300px;

        td {
          padding-bottom: 2px;
          font-size: 0.9rem;
          color: #000;
          letter-spacing: -0.3px;

          :last-child { text-align: right; }
        }

        td.label { font-weight: 700; }
        td.price { font-weight: 700; color: ${colors.primary}; }

        tr { padding-bottom: 5px; }
      }

      .fa-question-circle {
        color: ${colors.primary};
        margin-left: 6px;
        margin-bottom: -2px;
        cursor: pointer;
      }

      .popover {
        max-width: 280px;
        width: 280px;
        position: absolute;
        margin: -155px 35px 0 -15px;
        background-color: #FFF;
        border-radius: 8px;
        border: 1px solid #DDDDDD;
        -webkit-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.05);
        -moz-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.05);
        box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.05);

        div.text {
          padding: 15px;
          font-weight: 400;
        }
      }
    }
  }

  @media screen and (max-width: 519px) {
    .progress-bar {
      flex-direction: column;
      margin: 15px 0 !important;
      height: auto !important;

      .dot { display: none; }
      .bar { display: none; }

      .dot-container {
        margin-bottom: 5px;

        .status-container {
          position: initial !important;
          margin-top: 0 !important;
        }
      }
    }

    .order-totals {
      padding: 10px !important;

      .popover {
        width: 250px !important;
        max-width: 250px !important;
        margin-top: -170px !important;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .progress-bar {
      width: 70% !important;
    }

    .row-2 {
      flex-direction: column;
      margin-bottom: 15px !important;

      .info { margin-bottom: 15px; }
    }
  }
`;

export const Table = styled.div`
  table.lg {
    width: 100%;
    border: 1px solid #F1F1F1;

    tr, td, th {
      padding: 10px;
      border: 1px solid #F1F1F1;
      font-size: 0.9rem;
    }

    .thead {
      background-color: #F1F1F1;

      th {
        font-weight: 600;
        letter-spacing: -0.5px;
        color: #999;
        text-transform: uppercase;
        border-right: 1px solid #E9E9E9;

        :last-child { border: none; }
      }
    }

    td span.comment {
      color: #999;
      font-size: 0.8rem;
    }
  }

  table.sm {
    display: none;

    tr, td, th {
      padding: 10px;
      border: 1px solid #F1F1F1;
      font-size: 0.9rem;
    }

    th {
      font-weight: 600;
      letter-spacing: -0.5px;
      color: #999;
      text-transform: uppercase;
    }

    td span.comment {
      color: #999;
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 519px) {
    table.lg { display: none; }
    table.sm { display: block; }
  }

`;
